import styled from '@mui/system/styled';
import { Card } from '@mui/material';
import { t } from 'i18next';

export const StyledBookingTypeCard = styled(Card)`
  border-radius: 5px;
  padding: 3px 20px 3px 20px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  margin: 0 10px 0 10px;
  transition: 0.3s;
  no-wrap: true;
  text-align: center;
  box-shadow: none;

  @media (max-width: 1100px) {
    padding: 5px 5px 5px 5px;
    margin: 0 5px 0 5px;
    height: min-content;
    font-size: 10px;
    font-weight: 500;
    min-width: 100px;
  }
`;

export default function BookingCancelLabel() {
  return (
    <StyledBookingTypeCard
      sx={{
        color: '#FF5858',
        background:
          'linear-gradient(175.46deg, rgba(255, 154, 154, 0.15) -9.81%, rgba(255, 88, 88, 0.15) 96.32%)',
      }}
    >
      {t('bookings.cancelled')}
    </StyledBookingTypeCard>
  );
}
